const breakpoints = {
    min: {
        xs: '22.5em',
        sm: '30em',
        md: '48em',
        lg: '64em',
        xl: '80em',
        '2xl': '96em'
    },
    max: {
        xs: '22.4875em',
        sm: '29.9875em',
        md: '47.9875em',
        lg: '63.9875em',
        xl: '79.9875em',
        '2xl': '95.9875em'
    }
}

export const media = (
    point: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl',
    media: 'min' | 'max' = 'min'
) => {
    return `(${media}-width: ${breakpoints[media][point]})`
}
